<template>
    <div id="header">
        <div>
            <ec2-management></ec2-management>
        </div>
        <div id="container">
            <div id="source">
                <div class="multiselect"> <h3>Trainer Video</h3>
                    <Multiselect id="allVideos" class="multiS" v-model="videoData1" @input="handleSelect()"
                    placeholder="Select Single Video" label="title" :options="AllVideos"
                    :multiple="false" :loading="dataNotLoaded">
                    </Multiselect>
                </div>
                <iframe width="100%" height="400"
                    :src="video1Obj.embedId1"></iframe>
                <div>
                    <table width="90%">
                        <tr>
                            <th>VideoId</th>
                            <th>Duration</th> 
                            <th>Start Time</th>
                            <th>End Time</th>
                        </tr>
                        <tr>
                           <th>{{ video1Obj.videoId1 }} </th>
                           <th>{{ video1Obj.duration }}</th>
                           <th>{{ video1Obj.start }}</th>
                           <th>{{ video1Obj.end }}</th>
                        </tr>
                    </table>
                </div>
            </div>
            <div id="destination">
                <div class="multiselect"><h3>Test Video</h3>
                    <Multiselect id="allVideos" class="multiS" v-model="videoData2" @input="handleSelect()"
                    placeholder="Select Single Video" label="title" :options="AllVideos"
                    :clear-on-select="false" :close-on-select="true" :multiple="false" :loading="dataNotLoaded">
                    </Multiselect>
                </div>
                <iframe width="100%" height="400"
                :src="video2Obj.embedId2">
                </iframe>
                <div>
                    <table width="90%">
                        <tr>
                            <th>VideoId</th>
                            <th>Duration</th> 
                            <th>Start Time</th>
                            <th>End Time</th>
                        </tr>
                        <tr>
                            <th>{{ video2Obj.videoId2 }}</th>
                            <th>{{ video2Obj.duration }}</th>
                            <th>{{ video2Obj.start }}</th>
                            <th>{{ video2Obj.end }}</th>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="container2">
            <div class="page_header">
                <p class="information-text">Estimated Time of Test Completion: {{ durationRequired }} minutes</p>
                <div>
                    <b-button class="mr-2" variant="primary" size="md"  @click="startTest(videoId1, videoId2)">Begin Test</b-button>
                </div>
            <div style="height: 100%">
                    <div>
                        <div class="information-text-3">
                            <h4>Testing Report <b-button class="mr-2" variant="primary" size="sm" 
                                    v-on:click="onBtnExport()">Export CSV</b-button></h4>
                        </div>
                        <ag-grid-vue
                            style="width: 100%; height: 900px;"
                            class="ag-theme-alpine"
                            :columnDefs="columnDefs"
                            @grid-ready="onGridReady"
                            :defaultColDef="defaultColDef"
                            :rowSelection="rowSelection"
                            :rowData="rowData"
                            @selection-changed="onSelectionChanged">
                        </ag-grid-vue>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import b2bService from "@/module_admin/api/b2b-admin-service";
import Ec2Management from "@/module_admin/components/Ec2Management";
import { AgGridVue } from "ag-grid-vue";
import Multiselect from "vue-multiselect";
import api from '../api.js';
export default {
    name: 'anyTesting',
    data: function() {
        return {
            videoData1: undefined,
            videoData2:  undefined,
            AllVideos: [],
            DisplayVideosArray: [],
            videoId1: undefined,
            videoId2: undefined,
            embedId1: undefined,
            embedId2: undefined,
            dataNotLoaded: true,
            durationRequired: 0,
            video1Obj: [],
            video2Obj: [],
            columnDefs: [
                { field: 'video_id', filter: 'agNumberColumnFilter' },
                { field: 'type' },
                { field: 'score', filter: 'agNumberColumnFilter' },
                { field: 'tested_with', filter: 'agNumberColumnFilter' },
                { field: 'scoring_logic', filter: 'agNumberColumnFilter' },
                { field: 'time_taken', filter: 'agNumberColumnFilter' },
                { field: 'last_tested', filter: 'agDateColumnFilter', filterParams: filterParams,},
                { field: 'session_id'}
            ],
            gridApi: null,
            columnApi: null,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                minWidth: 100,
                flex: 1,
            },
            rowData: null,
            testResponseMessage: ''
        }
    },
    components: {
    'ag-grid-vue': AgGridVue,
    Ec2Management,
    Multiselect
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = '';
            var maxToShow = 5;
            selectedRows.forEach(function (selectedRow, index) {
            if (index >= maxToShow) {
                return;
            }
            if (index > 0) {
                selectedRowsString += ', ';
            }
            selectedRowsString += selectedRow.video_id;
            });
            if (selectedRows.length > maxToShow) {
            var othersCount = selectedRows.length - maxToShow;
            selectedRowsString +=
                ' and ' + othersCount + ' other' + (othersCount !== 1 ? 's' : '');
            }
            document.querySelector('#selectedRows').innerHTML = selectedRowsString;
        },
        onBtnExport() {
            this.gridApi.exportDataAsCsv();
        },
        async searchVideo() {
            if (this.AllVideos.length == 0) {
                await b2bService.getProgramDropdownItems().then((resp) => {
                    if (resp.code === 200) {
                        this.dataNotLoaded = false;
                        const data = resp.data;
                        this.authors = data.authors;
                        this.AllVideos = data.videos;
                    }
                    this.videoData1 = this.AllVideos[0];
                    this.videoData2 = this.AllVideos[1];
                    this.handleSelect();
                })
            }
        },
        async handleSelect() {
            if(this.videoData1 != undefined) {
                this.video1Obj = {
                        videoId1: this.videoData1.id,
                        embedId1: "https://www.youtube.com/embed/" + this.videoData1.youtube_embed_id,
                        duration: this.videoData1.duration,
                        start: this.videoData1.start,
                        end: this.videoData1.end,
                    }
            }
            if(this.videoData2 != undefined) {
                this.video2Obj = {
                        videoId2: this.videoData2.id,
                        embedId2: "https://www.youtube.com/embed/" + this.videoData2.youtube_embed_id,
                        duration: this.videoData2.duration,
                        start: this.videoData2.start,
                        end: this.videoData2.end,
                    }
            }
            this.durationRequired = Math.min(this.video1Obj.duration, this.video2Obj.duration);
            this.durationRequired = Math.round((this.durationRequired/60)/10);
            this.videoData1 = undefined;
            this.videoData2 = undefined;
        },
        async onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            const updateData = (data) => {
                this.rowData = data;
             };
            let testingData = await api.getAnyTestData();
            updateData(testingData);
        },
        async startTest(videoId1, videoId2) {
            try {            
                let data = {
                "videoId1": this.video1Obj.videoId1,
                "videoId2": this.video2Obj.videoId2
                }
                this.testResponseMessage = await api.startVideoTesting(data);
                if (this.testResponseMessage.status == 200) {
                    this.$bvToast.toast(`Test Request Submitted!! Estimated Time: ${this.durationRequired} mins`,
                    { variant: "success" });
                }
                else {
                    this.$bvToast.toast(`Failed to start Test`,
                    { variant: "danger" });
                }
                this.videoData1 = undefined;
                this.videoData2 = undefined;
            }
            catch {
                this.$bvToast.toast("Failed to start test!!",
                {variant: "danger"});
            }
        },
    },
    created() {
        this.rowSelection = 'multiple';
    },
    mounted() {
        this.searchVideo();
    }
    
};
var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
        var dateAsString = cellValue;
        if (dateAsString == null) return -1;
        var dateParts = dateAsString.split('/');
        var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
        return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
        return 1;
        }
        return 0;
    },
}
</script>
<style scoped>
 @import "~ag-grid-community/styles/ag-grid.css";
 @import "~ag-grid-community/styles/ag-theme-alpine.css";
#source {
    width: 50%;
    float: left;
    height: 100%
}
#destination {
    width: 50%;
    float: right;
    height: 100%;
}
table, th, td {
  border: 1px solid white;
  color: black;
  text-align: left;
}
.title {
    color:aliceblue;
    text-align: center;
    font-size: medium;
    width:60%;
}
.test-details{
    text-align: center;
    margin-top: 15px;
    font-size: 25px;
}
.custom-btn {
  background-color: #04AA6D;
  border-radius: 5px;
  color: black;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  margin: 4px 2px;
}
.time-estimate-label{
    position: relative;
    color: white;
}
#container {
    margin-top: 10px;
}

.page_header {
    text-align: center;
}

h3 {
    color: black;
}
.multiS {
    color: rgb(7, 7, 7);
}

.container2{
    margin-top: 30%;
}

.information-text{
    font-size: 30px;
    margin-top: 34%;
}
.information-text-2{
    color: red;
    text-align: center;
    font-size: xx-large;
}

.information-text-3 {
    margin-top: 1%;
}
</style>
